<template>
  <div class="flex-center">
    <div class="import-box">
      <h1>{{ $t('csv.csvPatients') }}</h1>
      <p>
        {{ $t('csv.csvMessageInfo1') }}
        <a @click="doDownloadDefaultCsv()">{{ $t('csv.csvMessageInfo2') }}</a>
        {{ $t('csv.csvMessageInfo3') }}
        <a @click="showCsvInstructions()">{{ $t('csv.csvMessageInfo4') }}</a>.
      </p>
      <div class="alert alert-warning" role="alert" v-if="importInProgress">
        <h4>{{ $t('csv.alertMessage') }}</h4>
        <p>
          {{ $t('csv.textAlertMessage') }}
        </p>
      </div>

      <div class="alert alert-warning" role="alert">
        <h4>{{ $t('csv.important') }}</h4>
        <p>
          {{ $t('csv.importantMessage') }}
        </p>
      </div>

      <div class="form-floating">
        <input class="file-input-hidden" id="formFile" type="file" ref="formFile" accept=".csv" @change="handleFileUpload()"/>

        <div class="file-chooser">
          <span class="file-name">{{ fileNameDisplay }}</span>
          <button type="button" class="btn-choose" @click="$refs.formFile.click()">{{ $t('clinic.buttonSearch') }}</button>
        </div>
      </div>

      <button class="btn btn-success" type="button" name="button" :disabled="!isValidCsv || !formData.file || loading || importInProgress || checkFailed" @click="canStartNewUpload()">{{ $t('csv.send') }}</button>
    </div>

    <ClinicCsvOffcanvas :offcanvas_id="'clinicCsvOffcanvas'" ref="clinicCsvOffcanvas" @downloadTemplate="doDownloadDefaultCsv"/>
    <BaseGenericOffcanvas :offcanvas_id="'offcanvasImportCsvGeneric'" ref="offcanvasGeneric"/>
  </div>
</template>

<style lang="scss" scoped>
.flex-center {
  align-items:                       flex-start !important;
  height:                            100%;
}

.import-box {
  text-align:                        center;
  width:                             100%;
  max-width:                         617px;
  display:                           flex;
  flex-direction:                    column;
  gap:                               18px;

  h1,
  p,
  .alert {
    color:                           var(--Brand-Primary);
    margin:                          0;
  }

  .alert {
    h4, p {
      color:                         #1B294A;
    }
  }

  h1 {
    font-size:                       38px;
    font-weight:                     300;
    line-height:                     normal;
  }

  p {
    font-size:                       var(--font-size-14);
    font-weight:                     400;
    line-height:                     140%; /* 19.6px */
    padding:                         0 1.2rem;

    a {
      color:                         inherit;
      text-decoration:               underline;
      cursor:                        pointer;
    }
  }

  .alert {
    @include                         border_radius(10px);
    padding:                         10px;
    background:                      #FFEBCB;
    border:                          1px #D1A660;
    h4 {
      font-size:                     var(--font-size-14);
      font-weight:                   400;
      line-height:                   140%; /* 19.6px */
      letter-spacing:                2.8px;
      text-transform:                uppercase;
      margin-bottom:                 10px;
    }

    p {
      font-size:                     var(--font-size-12);
      padding:                       0;
    }
  }
}

.form-control.form-control-lg {
  color:                             var(--Shades-50, #8F8F8F);
  font-size:                         13px;
  font-weight:                       400;
  letter-spacing:                    1.95px;
  text-transform:                    uppercase;
  line-height:                       2.5;
  position:                          relative;
  padding-top:                       0.625rem !important;

  &::file-selector-button {
    @include                         border_radius(99px);
    color:                           var(--Shades-W, var(--W, #FFF));
    font-size:                       var(--font-size-12);
    font-weight:                     700;
    line-height:                     normal;
    letter-spacing:                  3.6px;
    text-transform:                  uppercase;
    padding:                         10px;
    background:                      var(--Brand-Secondary, #3CB391);
    border:                          0;
    position:                        absolute;
    right:                           0;
    top:                             19px;
  }
}

.btn-success {
  font-size:                         var(--font-size-14);
  font-weight:                       700;
  letter-spacing:                    4.2px;
  padding:                           20px;
}

@media (max-width: 991px) {
  .flex-center {
    padding:                         0 10px;
  }

  .import-box {
    gap:                             8px;

    h1 {
      font-size:                     var(--font-size-20);
    }

    p {
      font-size:                     var(--font-size-12);
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  .import-box {
    gap:                             10px;
  }
}

.file-input-hidden {
  display:                           none;
}

.file-chooser {
  display:                           flex;
  justify-content:                   space-between;
  align-items:                       center;
  border:                            1px solid var(--Shades-60-Border);
  border-radius:                     5px;
  padding:                           12px;
  background-color:                  var(--Shades-W, var(--W, #FFF));
}

.file-name {
  color:                             var(--Shades-50, #8F8F8F);
  text-align:                        left;
  font-size:                         13px;
  font-weight:                       400;
  letter-spacing:                    1.95px;
  text-transform:                    uppercase;
  line-height:                       2.5;
  overflow:                          hidden;
  white-space:                       nowrap;
  text-overflow:                     ellipsis;
  flex-grow:                         1;
}

.btn-choose {
  @include border_radius(99px);
  color:                             var(--Shades-W, var(--W, #FFF));
  font-size:                         var(--font-size-12);
  font-weight:                       700;
  line-height:                       normal;
  letter-spacing:                    3.6px;
  text-transform:                    uppercase;
  padding:                           10px;
  background:                        var(--Brand-Secondary, #3CB391);
  border:                            0;
  cursor:                            pointer;
}

// rule thtat get any device with IOS
@supports (-webkit-touch-callout: none) {
  @media (max-width: 991px) {
    .flex-center {
      height:                        calc(100svh - 200px);
      overflow-y:                    scroll !important;
    }
  }
}
</style>

<script>
import ClinicCsvOffcanvas from './ClinicCsvOffcanvas.vue'
import { useUserStore } from '@/store/user'
import { getCsvHeaderRow, getCsvInstructionKeys } from '@/utils/csvImportConfig'

export default {
  name: 'ClinicimportTab',
  props: {
    clinic_id: { type: [String, Number] },
  },
  components: {
    ClinicCsvOffcanvas
  },
  computed: {
    isGlobalClient() {
      const userStore = useUserStore();
      return userStore.sessionInfo?.isGlobalClient ?? false;
    }
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    clinic: {},
    formData: {},
    isValidCsv: true,
    importInProgress: false,
    checkFailed: false,
    fileNameDisplay: ''
  }),
  mounted() {
    this.fetchData()
    this.checkImportInProgress()
    this.$nextTick(() => {
        this.fileNameDisplay = this.$i18n.t('clinic.noFileSelected');
    });
  },
  methods: {
    async fetchData() {
      await this.$helpers.requestHandling(async () => {
        const params = {
          id: this.clinic_id
        }

        const response = await this.$clinicService.getClinic(params);
        this.clinic = response.clinic
      }, this, (err) => `Error: ${err.message}`, 'operationFail');
    },
    async checkImportInProgress() {
      try {
        const check = await this.$clinicService.canStartNewImport({ clinicId: this.clinic_id })
        this.importInProgress = check.status !== true
      } catch (error) {
        this.checkFailed = true
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      }
    },
    handleFileUpload() {
      this.isValidCsv = true
      this.formData.file = this.$refs.formFile.files[0]
      this.formData.clinic = this.clinic
      let regexCsv = /(.*?)\.(csv)$/;

      if (this.formData.file) {
        this.fileNameDisplay = this.formData.file.name;
      } else {
        this.fileNameDisplay = this.$i18n.t('clinic.noFileSelected');
      }

      if (!regexCsv.test(this.formData.file.name)) {
        this.isValidCsv = false
        this.$message.popup(this, 'csv.invalidCsv', 'operationFail', 'error')
      }

      if (this.formData.file.size > 1048576) { // validando 1mb
        this.isValidCsv = false
        this.$message.popup(this, 'csv.fileMaxSize', 'operationFail', 'error')
      }
    },

    async canStartNewUpload() {
      let check

      this.loading = true
      NProgress.start()
      try {
        check = await this.$clinicService.canStartNewImport({clinicId: this.clinic_id})
        if (check.status == true) {
          let uploadResult
          try {
            uploadResult = await this.$clinicService.uploadPatientCsvFile(this.formData)
            this.doImportCSV(uploadResult.filename)
          } catch (error){
            this.$message.popup(this, 'csv.errorUpload', 'operationFail', 'error')
          }
        } else {
          this.importInProgress = true
          this.$message.popup(this, 'csv.errorForbidenMessage', 'operationFail', 'error')
        }
      } catch(error) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },

    async doImportCSV(filename) {
      this.loading = true
      NProgress.start()
      try {
        let params = {
          clinic:  this.clinic,
          filename
        }
        let responseValidate = await this.$clinicService.validateCsvFile(params)
        if (responseValidate){
          this.$message.popup(this, 'csv.validData', 'operationSuccess', 'success')
          try {
            await this.$clinicService.importPatientsToClinic(params)
            this.$message.popup(this, 'csv.updateTable', 'operationSuccess', 'success')
          } catch (err) {
            this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
          }
        }
      } catch (err) {
        NProgress.done(true)
        this.loading = false

        const emptyOrMissingHeader = err.response.data.emptyOrMissingHeader || false
        const ok = await this.$refs.clinicCsvOffcanvas.show({
          title: this.$i18n.t(emptyOrMissingHeader ? 'csv.csvEmptyOrMissingHeaderTitle' : 'csv.errorInfoTitle'),
          text: err.response.data.invalidRows,
          emptyOrMissingHeader,
          okButton: 'OK',
          okButtonClass: 'btn-success',
        })
        if (ok) {
          this.$refs.formFile.value = ''
          this.formData = {}
        }
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },

    async doDownloadDefaultCsv() {
      let row = getCsvHeaderRow(this.clinic.locale, this.isGlobalClient)
      let csvContent = row.join(",");

      let encodedUri = await encodeURI(csvContent)
      let blob = new Blob([encodedUri], { type: "data:text/csv;charset=utf-8," });
      let url = URL.createObjectURL(blob);

      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download',`template_import_patients_phelcom_${this.clinic.locale}.csv`);
      link.click();
    },

    async showCsvInstructions() {
      const extraFieldsList = getCsvInstructionKeys(this.isGlobalClient)
        .map(key => `<li>${this.$i18n.t(key)}</li>`)
        .join('')

      let textInformation = `
        <p>${this.$i18n.t('csv.csvInstructions')}</p>
        <ul class="mb-0">
          <li>${this.$i18n.t('csv.csvRequiredField')}</li>
          <li>${this.$i18n.t('csv.csvBirthday')}</li>
          <li>${this.$i18n.t('csv.mandatoryInfo')}</li>
          <ul class="mb-0">
            <li>${this.$i18n.t('csv.mandatoryInfo1')}</li>
            <li>${this.$i18n.t('csv.mandatoryInfo2')}</li>
            <li>${this.$i18n.t('csv.mandatoryInfo3')}</li>
            <li>${this.$i18n.t('csv.mandatoryInfo4')}</li>
            <li>${this.$i18n.t('csv.mandatoryInfo5')}</li>
            <li>${this.$i18n.t('csv.mandatoryInfo6')}</li>
            ${extraFieldsList}
          </ul>
        </ul>
      `
      await this.$refs.offcanvasGeneric.show({
        title: this.$i18n.t('csv.csvGuidelines'),
        text: textInformation,
      })
    }
  }
}
</script>
